import type { StyleAttributes } from '../../../shared/types';
import { Badge } from '../ui';
import { cn } from '../../lib/utils';

const LABELS: Array<{ key: keyof StyleAttributes; label: string }> = [
  { key: 'tone', label: 'Tone' },
  { key: 'formality', label: 'Formality' },
  { key: 'sentenceStyle', label: 'Sentences' },
  { key: 'vocabulary', label: 'Vocabulary' },
  { key: 'emojiUsage', label: 'Emoji' },
  { key: 'humor', label: 'Humor' },
  { key: 'punctuationQuirks', label: 'Punctuation' },
  { key: 'ctaStyle', label: 'Calls to action' },
];

/** Renders an analyzed voice profile. WEB-4 owns the surrounding Style page. */
export function StyleAttributeList({
  attributes,
  className,
}: {
  attributes: StyleAttributes;
  className?: string;
}) {
  return (
    <div className={cn('space-y-4', className)}>
      <dl className="grid gap-3 sm:grid-cols-2">
        {LABELS.map(({ key, label }) => (
          <div key={key} className="space-y-0.5">
            <dt className="text-xs font-medium uppercase tracking-wide text-subtle">{label}</dt>
            <dd className="text-sm text-fg">{String(attributes[key] ?? '—')}</dd>
          </div>
        ))}
      </dl>
      <div className="flex flex-wrap gap-1.5">
        {attributes.do?.map((item) => (
          <Badge key={`do-${item}`} tone="success">
            {item}
          </Badge>
        ))}
        {attributes.dont?.map((item) => (
          <Badge key={`dont-${item}`} tone="danger">
            {item}
          </Badge>
        ))}
      </div>
    </div>
  );
}
